export const CLINICAL_PLANNERS_PATH = "/clinical-planners-consultants";
export const SHOW_CLINICAL_PLANNERS_IN_NAVIGATION = true;

const navigationCategoriesCache = new WeakMap();

export function isClinicalPlannersCategory(category) {
  return String(category?.name || "").trim().toLowerCase() ===
    "clinical planners & consultants";
}

export function getNavigationCategories(categories) {
  if (!Array.isArray(categories) || SHOW_CLINICAL_PLANNERS_IN_NAVIGATION) {
    return categories;
  }

  const cached = navigationCategoriesCache.get(categories);
  if (cached) return cached;

  const visibleCategories = categories.filter(
    (category) => !isClinicalPlannersCategory(category),
  );
  navigationCategoriesCache.set(categories, visibleCategories);
  return visibleCategories;
}
